import React from "react";
import styled from "styled-components";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import {
  GrupoUsuario,
  UsuarioListado,
} from "../../../services/seguridadServicios";
import FilaUsuario from "./FilaUsuario";

interface ListaUsuariosProps {
  usuarios: UsuarioListado[];
  grupos: GrupoUsuario[];
}

function ListaUsuarios({ usuarios, grupos }: ListaUsuariosProps) {
  return (
    <Row className="justify-content-center">
      <Col className="col-12 col-lg-6 col-xxl-4">
        <StyledCard>
          <StyledCardHeader>
            <h5>Usuarios</h5>
          </StyledCardHeader>
          <Card.Body>
            <ListGroup as="ol" numbered>
              {usuarios.map((usuario, index) => (
                <FilaUsuario
                  key={usuario.id}
                  usuario={usuario}
                  grupos={grupos}
                  indice={index + 1}
                />
              ))}
            </ListGroup>
          </Card.Body>
        </StyledCard>
      </Col>
    </Row>
  );
}

const StyledCard = styled(Card)`
  margin-bottom: 1.875rem;
  background-color: #fff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border: 0px solid transparent;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 13px 0px rgb(82 63 105 / 5%);
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background: transparent;
  padding: 1.25rem 1.25rem 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0px;
`;

export default ListaUsuarios;
